
import { BaseVue,EventBus } from "@newview/base-web";
import {
  changeTheme,
  comForm,
  textEditor,
  customModal,
  listview,
  updatePwd,
  loginout,
  userAvatar,
  changeSubsys,
} from "@newview/ui";
import userCenter from "./userCenter.vue";
import { Component, Watch, Prop } from "vue-property-decorator";
import splitPane from "vue-splitpane";
import {
  SysUserInforApi,
  StaticinforpageApi,
  UserInforApi,
  SubsysteminforApi,
  FileinforApi,
} from "@newview/system-api";
import { MessageApi } from "@newview/basicdata-api";
import { ShareroadtoinstitutionApi } from "@newview/basic-api";
import mainMenu from "./main-menu.vue";
let OSS = require("ali-oss");
import notification from "./notification.vue";
import noFondPage from "./noFondPage.vue";
@Component({
  name: "MainManage",
  components: {
    changeTheme,
    comForm,
    textEditor,
    splitPane,
    mainMenu,
    customModal,
    notification,
    listview,
    updatePwd,
    loginout,
    userAvatar,
    changeSubsys,
    userCenter,
  },
})
export default class MainManage extends BaseVue {
  @Prop({ default: () => [] }) menus!: Object; //表单项列表
  @Prop({ default: "" }) welComePagePath!: number; //欢迎页地址  
  @Prop({ default: 0 }) welComePageType!: number; //欢迎页参数，用来控制其他操作菜单 0：BIM+看板  1：看板   2：BIM   3：都没有
  @Prop({ default: () => false }) isShowRoleInfoBox!: boolean;
  @Prop({ default: () => true }) isHideTrigger!: boolean; // 控制是否显示Sider折叠图标 不显示true
  @Prop({ default: () => false }) userNoClick!: boolean; // 没有点击用户事件


  
  //#region api
  sysUserInforApi: SysUserInforApi = new SysUserInforApi();
  staticinforpageApi: StaticinforpageApi = new StaticinforpageApi();
  userInforApi: UserInforApi = new UserInforApi();
  subsysteminforApi: SubsysteminforApi = new SubsysteminforApi();
  fileinforApi: FileinforApi = new FileinforApi();
  messageApi: MessageApi = new MessageApi();
  shareroadtoinstitutionApi: ShareroadtoinstitutionApi =
    new ShareroadtoinstitutionApi();
  //#endregion
  //#region paramters
  activePnl: any = {};
  SubprojectShow = false;
  activeIndex = 1;
  HelpModel = false;
  silderIsShow = true;
  showBoard = false;
  leftActive = "pnl-active";
  rightActive = "";
  split1 = 0.5;
  imgUrl = "";
  subSystemName = ""; //业务系统
  subProjectName = ""; //项目实例
  isShowDoubleView = false;
  tab0 = true;
  tab1 = true;
  isshowfooter = false;
  activeHelpTab = "name0";
  activeTab1 = "";
  activeTab2 = "";
  activeTab: any = 0;
  sysName = this.$globalData_Plms.itemInfo.subProjectName;
  userName = this.$globalData_Plms.localUser.userTrueName;
  businessSystemList: any = [];

  nvIsCollapsed: Boolean = false;
  changePwdModal = false;
  changePwdIsClose = true;
  userInfoModal = false;
  subProjectList: any = [];
  allList: any = [];
  subSystemList: any = [];
  roadObj: any = {};
  subProjectId: any = 0;
  notifyList: any = [];
  content = "";
  HelpModelInfo: any = {
    token: this.NewGuid(),
    moduleId: 0,
    content: "",
  };
  formData: any = {};
  TabPaneList: any = [];
  TabPane2List: any = [];
  menuList: any = [];
  ContentBgUrl: any = "";
  activeMenu: any = localStorage.getItem("activeMenu");
  @Watch("activeMenu", { immediate: true })
  activeMenuChange(newVal: string, oldVal: string) {
    console.log("activeMenu 初始化或变化:", newVal);
    if(newVal && JSON.parse(newVal) && JSON.parse(newVal).moduleUrl=='/QTSmartJD/SmartData'){
      this.ContentBgUrl = require('../../../Web/tangqin-web/static/Image/MainManage/Mask_group.png') 
    }else{
      this.ContentBgUrl = '';
    }
    this.$nextTick(() => {
      EventBus.$emit("mainManageActiveMenu", newVal?JSON.parse(newVal):{});
    });
  }
  //#endregion
  //#region event
  async created() {
    // this.activeMenu="";
    // 获取到所有的子项目
    let params: any = sessionStorage.getItem("localUser");
    let param: any = JSON.parse(params);
    let list: any = param.projectdataList;
    this.allList = list;
    this.subProjectList = list;
    this.$Notice.close("model");
    let welComePage = require("./WelCome.vue").default;
    if(this.welComePagePath){
      welComePage = this.getLink(
        this.welComePagePath
      ).component;
    }
    this.TabPaneList.push({
      tab: "mainpage_tab1",
      label: "欢迎您：" + this.userName,
      icon: "ios-navigate-outline",
      name: '{"name":"欢迎您' + this.userName + '"}',
      component: welComePage,
      param: { type: this.welComePageType },
      closable: false,
    });
    this.activeTab1 = '{"name":"欢迎您' + this.userName + '"}';
    if (!this.isNull(this.activeMenu)) {
      let defaultMenu = JSON.parse(this.activeMenu);
      this.pushTabList(defaultMenu);
    }
    if (this.subProjectList[0].institutioninforList[0].roadList == null) {
      await this.getdata();
    }
  }
  mounted() {
    //解决IE11下路由跳转问题
    function checkIE() {
      return (
        "-ms-scroll-limit" in document.documentElement.style &&
        "-ms-ime-align" in document.documentElement.style
      );
    }
    if (checkIE()) {
      window.addEventListener(
        "hashchange",
        () => {
          let currentPath = window.location.hash.slice(1);
          if (this.$route.path !== currentPath) {
            this.$router.push(currentPath);
          }
        },
        false
      );
    }
    this.SubprojectShow = false;
    // this.info()
    // // this.openHelpInfo();
    // let timeAuto = setInterval(() => {
    //   //启动定时器发送请求
    //   this.info()
    // }, 600000)
  }
  javaEdit(data) {
    //帮助文档编辑数据回填
    this.content = data;
  }
  async openHelpInfo() {
    // 打开帮助文档
    this.HelpModel = true;
    let Nameds = JSON.parse(this.activeMenu);
    this.HelpModel = true;
    this.isshowfooter = true;
    let res = await this.staticinforpageApi.getStaticInforPage(Nameds.id);
    if (res.data != null) {
      this.HelpModelInfo = res.data;
      this.$nextTick(() => {
        this.activeHelpTab = "name0";
        this.ref("tabs").activeKey = "name0";
      });
    } else {
      this.$nextTick(() => {
        this.activeHelpTab = "name1";
        this.ref("tabs").activeKey = "name1";
      });
      this.HelpModelInfo.token = this.NewGuid();
      this.HelpModelInfo.moduleId = Nameds.id;
      this.HelpModelInfo.content = "";
      this.HelpModelInfo.id = "";
    }
  }
  clickLeftPnl() {
    this.leftActive = "pnl-active";
    this.rightActive = "";
  }
  clickRightPnl() {
    this.rightActive = "pnl-active";
    this.leftActive = "";
  }
  ToggleDoubleView() {
    //打开/关闭二个面板
    this.isShowDoubleView = this.isShowDoubleView ? false : true;
    if (this.isShowDoubleView) {
      this.rightActive = "pnl-active";
      this.leftActive = "";
      this.pushTab2List(JSON.parse(this.activeMenu));
    } else {
      this.TabPane2List = [];
    }
  }
  userCenterFun() {
    if(this.userNoClick){
      return
    }
    this.userInfoModal = true;
  }
  //子菜单点击触发
  clickLeftMenu(itemString, closable = true) {
    sessionStorage.setItem("menu", itemString);
    let _this = this;
    if (itemString == this.activeMenu) {
      return;
    }
    this.activeMenu = itemString;
    localStorage.setItem("activeMenu", itemString);
    let itemObj = JSON.parse(itemString);

    let link = itemObj.moduleUrl;
    if (this.isShowDoubleView && this.rightActive == "pnl-active") {
      this.pushTab2List(itemObj);
    } else {
      this.pushTabList(itemObj, closable);
    }
    if (itemObj.userData) {
      //日志痕迹
      // this.setVisitInfo(
      //   `${itemObj.userData.Id}`,
      //   itemObj.userData.NodeName,
      //   itemObj.userData.AccessUrl
      // )
    }
  }
  //添加tab页
  pushTabList(itemObj, closable = true) {
    let isRepeat = false;
    for (const item of this.TabPaneList) {
      if (JSON.stringify(itemObj) == item.name) {
        isRepeat = true;
        this.activeTab1 = JSON.stringify(itemObj);
      }
    }
    if (!isRepeat) {
      let label = itemObj.moduleName;
      console.log(itemObj.moduleName, itemObj.moduleUrl);
      console.log("pushTabList", itemObj);
      this.TabPaneList.push({
        tab: "mainpage_tab1",
        label: label,
        name: JSON.stringify(itemObj),
        component:
          itemObj.loadType == 2
            ? this.getLink(itemObj.moduleUrl) != undefined
              ? this.getLink(itemObj.moduleUrl).component
              : "dynamicPage"
            : "dynamicPage",
        param: itemObj,
        closable: closable,
      });
      this.activeTab1 = JSON.stringify(itemObj);
    }
    console.log(this.TabPaneList);
  }
  pushTab2List(itemObj) {
    let isRepeat = false;
    for (const item of this.TabPane2List) {
      if (JSON.stringify(itemObj) == item.name) {
        isRepeat = true;
        this.activeTab2 = JSON.stringify(itemObj);
      }
    }
    if (!isRepeat) {
      let label = itemObj.moduleName;
      this.TabPane2List.push({
        tab: "mainpage_tab2",
        label: label,
        name: JSON.stringify(itemObj),
        component:
          itemObj.loadType == 2
            ? this.getLink(itemObj.moduleUrl) != undefined
              ? this.getLink(itemObj.moduleUrl).component
              : "dynamicPage"
            : "dynamicPage",
        param: itemObj,
      });
      this.activeTab2 = JSON.stringify(itemObj);
      console.log(itemObj.moduleUrl);
    }
  }
  //点击tab页签
  changeTabEvent(itemString) {
    if (itemString.indexOf("欢迎您")>-1){
      EventBus.$emit("refreshMytodoGrid")//重新刷新首页中间的gird,否则显示高度计算的有问题
    }
    this.activeMenu = itemString;
    localStorage.setItem("activeMenu", itemString);
    this.setVisitInfoByStringItem(itemString); //record
  }
  changeTab2Event(event) {
    this.setVisitInfoByStringItem(event); //record
  }
  //关闭tab页签
  removeTabEvent(itemString) {
    let _this = this;
    this.TabPaneList.forEach(function (item: any, index) {
      if (itemString == item.name) {
        _this.TabPaneList.splice(index, 1);
      }
    });
    this.activeMenu = this.activeTab1;
    this.setVisitInfoByStringItem(this.activeTab1); //record
    if (this.TabPaneList.length == 1) {
      this.activeMenu = "";
      EventBus.$emit("refreshMytodoGrid")//重新刷新首页中间的gird,否则显示高度计算的有问题
      localStorage.setItem("activeMenu", "");
    }
  }
  //关闭tab页签
  removeTab2Event(itemString) {
    let _this = this;
    this.TabPane2List.forEach(function (item: any, index) {
      if (itemString == item.name) {
        _this.TabPane2List.splice(index, 1);
      }
    });
    this.setVisitInfoByStringItem(this.activeTab2); //record
    if (this.TabPane2List.length == 0) {
      this.isShowDoubleView = false;
    }
  }
  //#endregion
  //#region method
  async getdata() {
    //获取共享线路信息
    if (this.subProjectList[0].institutioninforList[0].roadList == null) {
      let institutioninId = this.subProjectList[0].institutioninforList[0].id;
      let data: any = await this.shareroadtoinstitutionApi.getRoadInfor(
        institutioninId
      );
      if (data.code == 200) {
        // this.$globalData_Plms.roadInfo = data.data[0]
        this.$globalData_Plms.roadList = data.data;
      }
    }
  }
  async saveInfo() {
    // 保存帮助文档
    let param = JSON.parse(this.activeMenu);
    this.HelpModelInfo.moduleId = param.id;
    this.HelpModelInfo.content = this.content;
    let data: any = await this.staticinforpageApi.saveText(this.HelpModelInfo);
    if (data.code == 200) {
      this.success("保存成功");
      this.HelpModel = false;
    } else {
      this.error("保存失败");
      this.HelpModel = false;
    }
  }
  handleSaveUser() {
    //更新用户密码信息
    let _this = this;
    this.userInforApi.updateUserInfo(this.formData).then((res) => {
      if (res.code == 200) {
        this.$globalData_Plms.localUser.userTrueName =
          this.formData.userTrueName;
        this.$globalData_Plms.localUser.userPhone = this.formData.userPhone;
        this.$globalData_Plms.localUser.userIcon = this.formData.userIcon;
        sessionStorage.setItem(
          "localUser",
          JSON.stringify(this.$globalData_Plms.localUser)
        );
        _this.userInfoModal = false;
        _this.$Message.info("保存成功");
      } else {
        _this.$Message.info("保存失败");
      }
    });
  }

  getLink(path) {
    const data: any = this.Baselinq.from(this.menus).firstOrDefault(
      (item) => item["path"] === path
    );
    if (this.isNull(data)) {
      let dataA = {};
      dataA = { component: noFondPage };
      return dataA;
    } else {
      return data;
    }
  }
  loadMenuList(datas) {
    const treeDatas: any = this.Baselinq.from(datas)
      .where((x) => x["pid"] == 0)
      .orderBy((p) => p["orderNo"])
      .toArray();
    for (let data of treeDatas) {
      data.children = this.loadMenuChild(data.id, datas);
    }
    return treeDatas;
  }
  loadMenuChild(pid, datas) {
    const childDatas: any = this.Baselinq.from(datas)
      .where((x) => x["pid"] == pid)
      .orderBy((p) => p["orderNo"])
      .toArray();
    if (childDatas.length > 0) {
      for (let data of childDatas) {
        data.children = this.loadMenuChild(data.id, datas);
      }
    }
    return childDatas;
  }
  getSysColor(item, i) {
    let colors = ["#5A82F7", "#5AAFF7", "#5E5AF7", "#2DCAA3"];
    let index = Math.floor(Math.random() * 4);
    return colors[index];
  }
  async info() {
    //通知消息提示
    this.$Notice.close("model");
    let res = await this.messageApi.getMessageByUserId(
      this.$globalData_Plms.localUser.id
    );
    if (res.code == 200 && null != res.data && res.data.length > 0) {
      let isReadList: any = res.data.filter((e) => e.isRead == 1);
      if (isReadList.length > 0) {
        this.$Notice.config({
          top: 800,
        });
        this.$Notice.info({
          title: "您有待接收的任务~",
          name: "model", //key改为name
          duration: 0,
          render: (h: any) => {
            return h("div", [
              h(
                "div",
                {
                  style: "cursor:pointer",
                  on: {
                    click: ($event) => {
                      this.goToMore();
                    },
                  },
                },
                "您有新的消息，请到我的消息查看！"
              ),
            ]);
          },
        });
      }
    }
  }
  goToMore() {
    this.pushTabList({
      moduleName: "我的消息",
      moduleUrl: "personCenter/MyMessage",
    });
  }
  destroyed() {
    if (this.activeTab != 0) {
      localStorage.setItem("activeTab", this.activeTab.toString());
    } else {
      localStorage.setItem("activeTab", "");
    }
  }
}
